<!--
  Closes a history feed when the circle plan caps how far back it goes. Mirrors
  the Go app's HistoryUnlockCard: an upsell line plus a single "Unlock by upgrade"
  action. Purely an upsell - the server already withholds the older data.

  The whole circle sees the explanation (so a member understands why the feed is
  short), but only the circle OWNER gets the upgrade button, since /plans is
  owner-only; a non-owner sees a soft "ask your owner" line instead of a button
  that would bounce them to Settings.
-->
<template>
    <v-card variant="flat" rounded="lg" class="history-unlock-card pa-4">
        <div class="d-flex align-center ga-2 mb-1">
            <v-icon icon="mdi-crown-outline" color="primary" size="20"/>
            <span class="text-subtitle-2 font-weight-bold">More history with Premium</span>
        </div>
        <p class="text-body-2 text-medium-emphasis mb-3">{{ subtitle }}</p>
        <v-btn v-if="canUpgrade" color="primary" variant="flat"
               prepend-icon="mdi-crown" @click="$emit('upgrade')">
            Unlock by upgrade
        </v-btn>
        <p v-else class="text-caption text-medium-emphasis mb-0">
            Ask your circle owner to upgrade for more history.
        </p>
    </v-card>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
    // Best history a higher tier offers, for the copy; null -> generic wording.
    upgradeDays: {type: Number, default: null},
    // Whether this user can act on the upsell (circle owner).
    canUpgrade: {type: Boolean, default: false},
});

defineEmits(["upgrade"]);

const subtitle = computed(() =>
    props.upgradeDays
        ? `See up to ${props.upgradeDays} days of history with Premium.`
        : "See more history with Premium."
);
</script>

<style scoped>
.history-unlock-card {
    background: rgba(var(--v-theme-primary), 0.06);
}
</style>
